import { EntityPermissions, FieldPermissionRow } from "@/hooks/schema/use-my-permissions";
import { create } from "zustand";

export interface PermissionsState {
  entityPermissionsMap: Map<string, EntityPermissions>;
  setEntityPermissionsMap: (map: Map<string, EntityPermissions>) => void;
  // Per-entity permission rows carrying their `field_paths`, for per-field read/write gating.
  entityFieldPermissionsMap: Map<string, FieldPermissionRow[]>;
  setEntityFieldPermissionsMap: (map: Map<string, FieldPermissionRow[]>) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  // Flips true the first time permissions finish resolving. Unlike `isLoading`
  // (which defaults false before the queries even start), this is a reliable
  // "permissions are ready" signal for gating UI that depends on them.
  hasLoaded: boolean;
  setHasLoaded: (hasLoaded: boolean) => void;
  hasRootPrivileges: boolean;
  setHasRootPrivileges: (hasRootPrivileges: boolean) => void;
}

export const usePermissionsStore = create<PermissionsState>((set) => ({
  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),
  hasLoaded: false,
  setHasLoaded: (hasLoaded) => set({ hasLoaded }),
  entityPermissionsMap: new Map(),
  setEntityPermissionsMap: (map) => set({ entityPermissionsMap: map }),
  entityFieldPermissionsMap: new Map(),
  setEntityFieldPermissionsMap: (map) => set({ entityFieldPermissionsMap: map }),
  hasRootPrivileges: false,
  setHasRootPrivileges: (hasRootPrivileges) => set({ hasRootPrivileges }),
}));
